import {
  Users,
  Briefcase,
  Building2,
  Award,
  Landmark,
  ScrollText,
  HeartHandshake,
  Clock,
  CheckCircle2,
  Phone,
  Mail,
  MapPin,
  Star,
  ChevronRight,
  ChevronLeft,
  Menu,
  X,
  ShieldCheck,
  Scale,
  FileText,
  ArrowRight,
  Calendar,
  Quote,
} from "lucide-react";

export const ICONS = {
  Users,
  Briefcase,
  Building2,
  Award,
  Landmark,
  ScrollText,
  HeartHandshake,
  Clock,
  CheckCircle2,
  Phone,
  Mail,
  MapPin,
  Star,
  ChevronRight,
  ChevronLeft,
  Menu,
  X,
  ShieldCheck,
  Scale,
  FileText,
  ArrowRight,
  Calendar,
  Quote,
};

export const DynamicIcon = ({ name, className = "h-6 w-6", strokeWidth = 1.75 }) => {
  const Cmp = ICONS[name] || Scale;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};
